<div class="scale-container" [ngClass]="{ disabled: disabled }">
  <div class="scale-header" (click)="toggleExpanded()" style="cursor: pointer">
    <span class="scale-title">{{ title }}</span>
    <button
      type="button"
      class="scale-toggle"
      (click)="$event.stopPropagation(); toggleExpanded()"
      aria-label="Expandir o contraer escala"
      [attr.aria-expanded]="isExpanded()">
      <span class="material-symbols-rounded" [class.expanded]="isExpanded()">
        keyboard_arrow_down
      </span>
    </button>
  </div>

  <div class="scale-collapsible" [class.collapsed]="!isExpanded()">
    <div class="scale-collapsible-inner">
      <div class="scale-bar">
        <div
          class="color-bar"
          [ngStyle]="{ background: getColorGradient() }"></div>
        <div class="ticks-container">
          @for (
            tick of tickValues();
            track tick;
            let i = $index;
            let last = $last;
            let first = $first
          ) {
            <div
              class="tick-label"
              [ngClass]="{ 'tick-label-last': last }"
              [style.top]="(i / (tickValues().length - 1)) * 100 + '%'"
              [style.transform]="
                i === 0
                  ? ''
                  : i === tickValues().length - 1
                    ? 'translateY(-100%)'
                    : 'translateY(-50%)'
              ">
              <span
                [ngClass]="{
                  'scale-line-big': first || last,
                  'scale-line-small': !first && !last,
                }"></span
              ><span class="tick-number"> {{ tick | number: '1.2-2' }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
